const CATEGORY_COLORS: Record<string, string> = {
  household: '#6366F1',
  housing: '#F43F5E',
  groceries: '#3DD6A4',
  dining: '#F59E0B',
  transport: '#38BDF8',
  subscriptions: '#A78BFA',
  entertainment: '#EC4899',
  health: '#14B8A6',
  insurance: '#60A5FA',
  shopping: '#F97316',
  utilities: '#64748B',
  childcare: '#F472B6',
  other: '#94A3B8',
  salary: '#3DD6A4',
  investment: '#6366F1',
  transfer: '#38BDF8',
  payments: '#F59E0B',
  dividend: '#A78BFA',
  'interest-income': '#14B8A6',
  refund: '#F59E0B',
  'other-income': '#94A3B8',
};

const FALLBACK_PALETTE = [
  '#6366F1',
  '#3DD6A4',
  '#F59E0B',
  '#38BDF8',
  '#A78BFA',
  '#EC4899',
  '#14B8A6',
  '#F97316',
];

export function getCategoryColor(slug: string, index = 0): string {
  return CATEGORY_COLORS[slug] ?? FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
}
